<template>
  <form class="row g-3 needs-validation" novalidate>
    <div class="row" style="margin-bottom: 10px">
      <span class="page-title">Cadastro de Paciente</span>
    </div>
    <div class="row">
      <div class="alert alert-warning alert-dismissible fade show" style="margin: 10px" role="alert" v-if="sicad"><strong>Atenção !</strong> Atualize os dados do profissional no nosso sistema SICAD para concluir o cadastro.</div>
    </div>
    <div class="row" style="margin-top: 25px">
      <fieldset>
        <legend style="width: 160px">Dados Pessoais</legend>
        <div class="row">
          <div style="display: flex; flex-direction: column; max-width: 250px; max-height: 230px">
            <img class="rounded" alt="" id="imgFoto" style="flex: 1; object-fit: cover; max-width: 250px; max-height: 210px" />

            <input id="uploadImg" type="file" ref="uploadImg" v-on:change="uploadFileImg" />
            <a style="color: deepskyblue; text-align: center" id="upload_img" @click="openUploadImg" ref="uploadImgClick">Incluir foto</a>
          </div>

          <div class="col">
            <div class="row">
              <div class="col-12 col-md-6 col-lg-12 col-xl-8" style="padding: 0px 10px">
                <label for="nome">Nome completo</label>
                <input type="text" class="form-control form-input-component" v-model="form.nome" id="nome" aria-describedby="nome" v-bind:class="{ 'is-invalid': submitted && form.nome.length === 0 }" required disabled />
              </div>
              <div class="col-12 col-md-6 col-lg-6 col-xl-4" style="padding: 0px 10px">
                <label for="tipoPaciente">Tipo Paciente</label>
                <input type="text" class="form-control form-input-component" v-model="form.tipoPaciente" aria-describedby="tipoPaciente" id="tipoPaciente" v-bind:class="{ 'is-invalid': submitted && form.tipoPaciente.length === 0 }" required disabled />
              </div>
              <div class="col-12 col-md-6 col-lg-6 col-xl-8" style="padding: 0px 10px">
                <label for="cpf">CPF</label>
                <input type="text" class="form-control form-input-component" v-mask="'###.###.###-##'" v-model="form.cpf" ref="cpf" id="cpf" required v-bind:class="{ 'is-invalid': submitted && form.cpf.length === 0 }" @keyup="validarCpf" disabled />
              </div>
              <div class="col-12 col-md-6 col-lg-6 col-xl-4" style="padding: 0px 10px">
                <label for="situacao">Situação</label>
                <input type="text" class="form-control form-input-component" v-model="form.situacao" id="situacao" v-bind:class="{ 'is-invalid': submitted && !form.situacao.lenght === 0 }" required disabled />
              </div>
              <div class="col-12 col-md-12 col-lg-6 col-xl-3" style="padding: 0px 10px">
                <label for="rgCivil">RG Civil</label>
                <input type="text" class="form-control form-input-component" v-model="form.rgCivil" id="rgCivil" v-bind:class="{ 'is-invalid': submitted && !form.rgCivil }" required disabled />
              </div>

              <div class="col-12 col-md-3 col-lg-3 col-xl-2" style="padding: 0px 10px">
                <label for="rgMilitar">RG Militar</label>
                <input type="text" class="form-control form-input-component" v-model="form.rgMilitar" id="rgMilitar" v-bind:class="{ 'is-invalid': submitted && !form.rgMilitar }" required disabled />
              </div>

              <div class="col-12 col-md-6 col-lg-6 col-xl-5" style="padding: 0px 10px">
                <label>Data Nascimento</label>
                <input type="text" v-model="form.dtNascimento" class="form-control form-input-component" id="dtNascimento" v-bind:class="{ 'is-invalid': submitted && !form.dtNascimento }" required disabled />
              </div>
              <div class="col-12 col-md-6 col-lg-6 col-xl-2" style="padding: 0px 10px">
                <label for="idade">Idade</label>
                <input type="number" v-model="form.idade" class="form-control form-input-component" id="idade" v-bind:class="{ 'is-invalid': submitted && !form.idade }" required disabled />
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6 col-lg-4 col-xl-4">
            <label for="telefoneCelular">Telefone Celular</label>
            <input type="text" v-model="form.telefoneCelular" v-mask="'(##) #####-####'" class="form-control form-input-component" id="telefoneCelular" v-bind:class="{ 'is-invalid': submitted && !form.telefoneCelular }" required />
          </div>
          <div class="col-12 col-md-6 col-lg-4 col-xl-4">
            <label for="telefoneResidencial">Telefone Fixo</label>
            <input type="text" v-model="form.telefoneResidencial" v-mask="'(##) ####-####'" class="form-control form-input-component" id="telefoneResidencial" aria-required="false" />
          </div>
          <div class="col-12 col-md-6 col-lg-4 col-xl-4">
            <label for="naturalidade">Naturalidade</label>
            <input type="text" v-model="form.naturalidade" class="form-control form-input-component" id="naturalidade" v-bind:class="{ 'is-invalid': submitted && !form.naturalidade }" required disabled />
          </div>

          <div class="col-12 col-xs-12 col-md-6 col-lg-4 col-xl-4">
            <label>Estado Civil</label>
            <select class="form-select form-input-component" v-model="form.estadoCivil" v-bind:class="{ 'is-invalid': submitted && !form.estadoCivil }">
              <option v-for="item in estadosCivis" :key="item.id" :value="item">
                {{ item.nome }}
              </option>
            </select>
          </div>
          <div class="col-12 col-xs-12 col-md-6 col-lg-4 col-xl-4">
            <label>Grau de Escolaridade</label>
            <select class="form-select form-input-component" v-model="form.grauEscolaridade">
              <option v-for="item in grauEscolaridade" :key="item.id" :value="item">
                {{ item.nome }}
              </option>
            </select>
          </div>
          <div class="col-12 col-xs-12 col-md-6 col-lg-4 col-xl-4">
            <label>Data de Inclusão</label>
            <input type="text" v-model="form.dtInclusao" class="form-control form-input-component" id="dtInclusao" v-bind:class="{ 'is-invalid': submitted && !form.dtInclusao }" required disabled />
          </div>
        </div>
        <div class="row" style="margin-top: 10px">
          <div class="col-12 col-xs-12 col-md-6 col-lg-6 col-xl-6">
            <label for="nomeMae">Nome da Mãe</label>
            <input type="text" class="form-control form-input-component" v-model="form.nomeMae" id="nomeMae" aria-describedby="nomeMae" />
          </div>
          <div class="col-12 col-xs-12 col-md-6 col-lg-6 col-xl-6">
            <label for="nomePai">Nome do Pai</label>
            <input type="text" class="form-control form-input-component" v-model="form.nomePai" id="nomePai" aria-describedby="nomePai" />
          </div>
        </div>
      </fieldset>
    </div>

    <div class="row" style="margin-top: 25px">
      <fieldset>
        <legend style="width: 220px">Endereço Residencial</legend>
        <div class="row">
          <div class="row" style="margin-top: 10px">
            <div class="col-12 col-md-9 col-lg-9 col-xl-8">
              <label for="logradouro">Logradouro</label>
              <input type="text" class="form-control form-input-component" id="logradouro" v-model="outForm.logradouro" v-bind:class="{ 'is-invalid': submitted && !outForm.logradouro }" aria-describedby="logradouro" required />
            </div>
            <div class="col-12 col-md-3 col-lg-3 col-xl-4">
              <label for="numero">Número</label>
              <input type="text" v-model="outForm.numero" class="form-control form-input-component" id="numero" required />
            </div>
          </div>
          <div class="row" style="margin-top: 10px">
            <div class="col-12 col-xs-12 col-md- col-lg-4 col-xl-4">
              <label for="complemento">Complemento</label>
              <input type="text" class="form-control form-input-component" id="complemento" v-model="outForm.complemento" aria-describedby="complemento" />
            </div>
            <div class="col-12 col-xs-12 col-md-3 col-lg-2 col-xl-2">
              <label for="quadra">Quadra</label>
              <input type="text" v-model="outForm.quadra" class="form-control form-input-component" id="quadra" required />
            </div>
            <div class="col-12 col-xs-12 col-md-3 col-lg-2 col-xl-2">
              <label for="lote">Lote</label>
              <input type="text" v-model="outForm.lote" class="form-control form-input-component" id="lote" required />
            </div>
            <div class="col-12 col-xs-12 col-md-6 col-lg-4 col-xl-4">
              <label for="setor">Setor</label>
              <input type="text" v-model="outForm.setor" v-bind:class="{ 'is-invalid': submitted && !outForm.setor }" class="form-control form-input-component" id="setor" required />
            </div>
          </div>

          <div class="row" style="margin-top: 10px">
            <div class="col-12 col-xs-12 col-md-6 col-lg-5 col-xl-6">
              <label for="cidade">Cidade</label>
              <input type="text" class="form-control form-input-component" id="cidade" v-model="outForm.cidade" v-bind:class="{ 'is-invalid': submitted && !outForm.cidade }" aria-describedby="cidade" required />
            </div>
            <div class="col-12 col-xs-12 col-md-3 col-lg-3 col-xl-2">
              <label for="complemento">Estado</label>
              <input type="text" class="form-control form-input-component" id="estado" v-model="outForm.uf" v-bind:class="{ 'is-invalid': submitted && !outForm.uf }" aria-describedby="estado" required />
            </div>
            <div class="col-12 col-xs-12 col-md-3 col-lg-4 col-xl-4">
              <label for="cep">CEP</label>
              <input type="text" class="form-control form-input-component" id="cep" ref="cep" v-mask="'##.###-###'" @keyup="searchCep" v-model="outForm.cep" v-bind:class="{ 'is-invalid': submitted && $refs.cep.value.length === 0 }" required />
            </div>
          </div>
        </div>
      </fieldset>
    </div>

    <div class="row" style="margin-top: 25px">
      <fieldset>
        <legend style="width: 220px">Dados Profissionais</legend>
        <div class="row">
          <div class="row" style="margin-top: 10px">
            <div class="col-12 col-md-12 col-lg-12 col-xl-12" style="padding: 0px 10px">
              <label>Função Atual</label>
              <input type="text" class="form-control form-input-component" id="funcaoAtual" aria-describedby="funcaoAtual" required disabled />
            </div>
            <div class="col-12 col-md-12 col-lg-12 col-xl-6" style="padding: 0px 10px">
              <label>Posto/Graduação</label>
              <select class="form-select" v-model="form.posto">
                <option v-for="item in postoGraduacao" :key="item.id" :value="item">{{ item.nome }} - {{ item.sigla }}</option>
              </select>
            </div>
            <div class="col-12 col-md-12 col-lg-12 col-xl-6" style="padding: 0px 10px">
              <label for="email">E-mail</label>
              <input type="text" v-model="form.email" v-bind:class="{ 'is-invalid form-control form-input-component': submitted && !form.email }" ref="email" @keyup="validarEmail" class="form-control form-input-component" id="email" required />
            </div>
          </div>

          <div class="row" style="margin-top: 15px">
            <label class="form-check-inline" style="font-size: 14px; font-weight: bold">Convênio que atende:</label>
            <div class="row" style="display: flex; justify-content: center; align-items: center; margin: 0px; padding: 0px">
              <div class="col-12 col-xs-12 col-md-6 col-lg-6 col-xl-6 form-check-item">
                <div class="form-check form-check-inline form-check-item">
                  <input class="form-check-input form-checkbox-box" v-model="form.convenios" v-bind:class="{ 'is-invalid': submitted && !form.convenios.length != 0 }" type="checkbox" ref="ipasgo" value="IPASGO" id="ipasgo" v-on:change="setConvencio('IPASGO')" />
                  <label class="form-check-label" for="ipasgo"> Ipasgo </label>
                </div>
                <div class="form-check form-check-inline form-check-item" style="margin-left: 10px">
                  <input class="form-check-input form-checkbox-box" v-model="form.convenios" v-bind:class="{ 'is-invalid': submitted && !form.convenios.length != 0 }" type="checkbox" ref="doacao" value="DOACAO" id="doacao" v-on:change="setConvencio('DOACAO')" />
                  <label class="form-check-label" for="doacao"> Doação </label>
                </div>
                <div class="form-check form-check-inline form-check-item" style="margin-left: 10px">
                  <input class="form-check-input form-checkbox-box" v-model="form.convenios" v-bind:class="{ 'is-invalid': submitted && !form.convenios.length != 0 }" type="checkbox" ref="particular" value="PARTICULAR" id="particular" v-on:change="setConvencio('PARTICULAR')" />
                  <label class="form-check-label" for="particular"> Particular </label>
                </div>
              </div>
              <div class="col-12 col-xs-12 col-md-6 col-lg-6 col-xl-6">
                <label for="numeroConvenio">Número do Convênio</label>
                <input type="text" v-model="form.numeroConvenio" ref="numeroConvenio" class="form-control form-input-component" id="numeroConvenio" />
              </div>
            </div>
          </div>

          <div class="row" style="margin-top: 15px">
            <div class="col-12 col-xs-12 col-md-6 col-lg-6 col-xl-6">
              <label for="formFileSm" class="form-label">Tipo Documento</label>
              <select class="form-select form-input-component" ref="tipoDocumento">
                <option v-for="item in enumTipoDocumento" :key="item" :value="item.tipo">
                  {{ item.descricao }}
                </option>
              </select>
            </div>
            <div class="col-12 col-xs-12 col-md-6 col-lg-6 col-xl-6">
              <label for="formFileSm" class="form-label">Importar Arquivo</label>
              <input class="form-control form-control-sm form-input-component" id="formFileSm" type="file" name="file" ref="files" multiple v-on:change="uploadFile" />
            </div>
          </div>
          <div class="row" style="margin-top: 15px">
            <a-table :dataSource="dataDocuments" :columns="columns">
              <template #nomeArquivo="{ record }">
                <span>{{ record.nomeArquivo }}</span
                ><i class="fa-solid fa-file-arrow-down icon-download" style="margin-left: 15px; cursor: pointer" @click="baixarArquivo(record)"></i>
              </template>
              <template #tipoDocumento="{ record }">
                <span>{{ stringTipoDocumento(record) }}</span>
              </template>
              <template #action="{ record }">
                <a @click="removeDataArchive(record)"><i class="fas fa-trash icon-trash"></i></a>
              </template>
              <template>
                <a-pagination :total="500" />
              </template>
            </a-table>
          </div>
        </div>
      </fieldset>
    </div>

    <div class="row justify-content-end" style="margin-top: 10px">
      <div class="col">
        <div class="float-end">
          <button type="button" class="btn btn-primary" @click="this.$router.push({ path: '/paciente-page' })">Voltar</button>&nbsp;
          <button type="button" class="btn btn-primary" @click="saveAndContinue(v$.form.$invalid, false)">Salvar e continuar</button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { EnderecoModel } from '@/components/models/endereco';
import { EnumTipoDocumentoPaciente } from '@/components/models/enumTipoDocumentoPaciente';
import { createPaciente, getPacienteById } from '@/components/service/pacienteService';
import { domainEstadosCivisSicad, domainGrauEscolaridade, getUserByCpf } from '@/config/servicos-utils';
import { downloadDocumentFileWs, isArquivoValido, loadDocumentFileWs, sendDocumentFileWs } from '@/utils/filews';
import { openNotification, typesNotification } from '@/utils/notifications';
import { convertBase64ToBlob, domainPostoGraduacao, imgToBase64, isEmail, searchCepService, validarCpf } from '@/utils/servicos-utils';
import { useVuelidate } from '@vuelidate/core';
import { email, minLength, required } from '@vuelidate/validators';
import moment from 'moment';
import loadGif from '../../../assets/load.gif';
import imgPaciente from '../../../assets/paciente.jpeg';

export default {
  name: 'FormPacienteMilitar',
  components: {},
  props: {
    idPac: {
      type: String,
      required: false,
    },
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      errors: [],
      dataDocuments: [],
      postoGraduacao: [],
      submitted: false,
      especialidade: [],
      subEspecialidade: [],
      enumTipoDocumento: [],
      funcoesAtivas: [],
      estadosCivis: [],
      grauEscolaridade: [],
      carregado: false,
      sicad: false,
      columns: [
        {
          title: 'Tipo Documento',
          dataIndex: 'tipoDocumento',
          key: 'tipoDocumento',
          slots: { customRender: 'tipoDocumento' },
        },
        {
          title: 'Arquivo',
          dataIndex: 'nomeArquivo',
          key: 'nomeArquivo',
          slots: { customRender: 'nomeArquivo' },
        },
        {
          title: 'Ações',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
      form: {
        tipoPaciente: undefined,
        id: undefined,
        cpf: undefined,
        nome: undefined,
        rgCivil: undefined,
        rgMilitar: undefined,
        naturalidade: undefined,
        telefoneCelular: '',
        telefoneResidencial: '',
        estadoCivil: undefined,
        grauEscolaridade: undefined,
        endereco: undefined,
        idAnexoFileImg: undefined,
        dtNascimento: undefined,
        dtInclusao: undefined,
        idade: undefined,
        nomeMae: undefined,
        nomePai: undefined,
        email: undefined,
        posto: undefined,
        convenios: [],
        numeroConvenio: undefined,
        documentos: [],
        imagem: undefined,
        situacao: undefined,
      },

      outForm: {
        numero: undefined,
        complemento: undefined,
        logradouro: undefined,
        setor: undefined,
        cidade: undefined,
        uf: undefined,
        lote: undefined,
        quadra: undefined,
      },
    };
  },
  validations() {
    return {
      form: {
        cpf: {
          required,
          min: minLength(14),
        },
        nome: {
          required,
        },
        telefoneCelular: {
          required,
        },
        endereco: {
          required,
        },
        idade: {
          required,
        },
        estadoCivil: {
          required,
        },
        grauEscolaridade: {
          required,
        },
        email: {
          required,
          email,
        },
        tipoPaciente: {
          required,
        },
        convenios: {
          required,
        },
      },
    };
  },
  async created() {
    await this.onInit();
  },
  methods: {
    async onInit() {
      await this.getPostoGraduacao();
      await this.getEstadosCivisSicad();
      await this.getGrauEscolaridade();
      this.getTipoDocumento();

      if (localStorage.getItem('cpf')) {
        let cpf = localStorage.getItem('cpf');
        await this.patchFormSicad(cpf.replace('-', '').replaceAll('.', ''));
        localStorage.removeItem('cpf');
      } else {
        if (this.idPac) {
          this.$route.query.id = this.idPac;
        }
        if (this.$route.query.id && !this.carregado) {
          await getPacienteById(this.$route.query.id).then(async (p) => {
            document.getElementById('imgFoto').src = loadGif;
            this.form = p.data;
            await this.patchFormSicad(p.data.cpf);
            await this.patchForm();
            this.carregado = true;
          });
        } else {
          document.getElementById('imgFoto').src = imgPaciente;
          this.$router.push('/paciente-page');
        }
      }
    },
    async patchForm() {
      // endereço
      this.outForm.cep = this.form.endereco.cep;
      this.outForm.logradouro = this.form.endereco.logradouro;
      if (this.form.endereco.bairro && this.form.endereco.bairro.id) {
        this.outForm.setor = this.form.endereco.bairro.nome;
      } else {
        this.outForm.setor = this.form.endereco.bairro;
      }

      if (this.form.endereco.municipio && this.form.endereco.municipio.id) {
        this.outForm.cidade = this.form.endereco.municipio.nome;
        this.outForm.uf = this.form.endereco.municipio.uf;
      } else {
        this.outForm.cidade = this.form.endereco.cidade;
        this.outForm.uf = this.form.endereco.uf;
      }
      this.outForm.numero = this.form.endereco.numero;
      this.outForm.complemento = this.form.endereco.complemento;
      this.outForm.lote = this.form.endereco.lote;
      this.outForm.quadra = this.form.endereco.quadra;
      this.$refs.cep.value = this.form.endereco.cep;

      this.form.endereco = this.outForm;
      // convenios
      this.form.convenios.forEach((c) => {
        switch (c) {
          case 'PARTICULAR':
            this.$refs.particular.checked = true;
            break;
          case 'DOACAO':
            this.$refs.doacao.checked = true;
            break;
          case 'IPASGO':
            this.$refs.ipasgo.checked = true;
            break;
          default:
            break;
        }
      });
      // documentos
      this.dataDocuments = this.form.documentos;
      //carregar img
      await this.carregarImg(this.form.idAnexoFileImg);
    },
    async patchFormSicad(cpf) {
      await getUserByCpf(cpf).then(async (r) => {
        let dataNascimento = new Date(r.data.dtNascimento);
        let dataInclusao = new Date(r.data.dtInclusao);
        this.form.cpf = cpf;
        this.form.dtNascimento = moment(dataNascimento).format('DD/MM/YYYY');
        this.form.dtInclusao = moment(dataInclusao).format('DD/MM/YYYY');
        this.form.imagem = r.data.imagem;
        this.form.situacao = r.data.status;
        this.form.tipoPaciente = 'MILITAR';
        this.form.nome = r.data.nome;
        await this.funcaoAtiva(r.data);
        if (!this.$route.query.id) {
          await this.patchDataSicad(r.data);
        }
      });
    },
    async uploadFile() {
      let validarTamanho = isArquivoValido('', '', this.$refs.files.files[0].size, true);
      if (this.$refs.tipoDocumento.value) {
        if (validarTamanho.tamanho) {
          await sendDocumentFileWs(this.$refs.files.files[0], 'TOKEN', 'ssp').then((r) => {
            const obj = {
              idAnexoFileWs: r.data.id,
              tipoDocumento: this.$refs.tipoDocumento.value,
              nomeArquivo: r.data.nomeOriginal,
            };
            this.dataDocuments.push(obj);
            openNotification(typesNotification.success, 'Arquivo enviado com sucesso');
          });
        } else {
          openNotification(typesNotification.error, 'Tamanho de arquivo não suportado.');
        }
      }
    },
    async searchCep() {
      if (this.$refs.cep.value.length === 10) {
        await searchCepService(this.$refs.cep.value.replace('.', '').replace('-', '')).then((r) => {
          if (r.data && r.data[0]) {
            this.outForm = {};
            this.form.endereco = EnderecoModel(r.data[0]);
            this.outForm.cep = this.$refs.cep.value;
            this.outForm.logradouro = EnderecoModel(r.data[0]).logradouro;
            this.outForm.setor = EnderecoModel(r.data[0]).bairro;
            this.outForm.cidade = EnderecoModel(r.data[0]).cidade;
            this.outForm.uf = EnderecoModel(r.data[0]).uf;
          }
        });
      }
    },
    removeDataArchive(record) {
      if (!this.form.id) {
        this.dataDocuments.splice(this.dataDocuments.indexOf(this.dataDocuments.find((r) => r.tipoDocumento === record.tipoDocumento && r.nomeArquivo === record.nomeArquivo)), 1);
      } else {
        this.form.documentos.splice(this.form.documentos.indexOf(this.form.documentos.find((r) => r.idAnexoFileWs === record.idAnexoFileWs)), 1);
        this.saveAndContinue();
      }
    },

    async getPostoGraduacao() {
      await domainPostoGraduacao().then((r) => (this.postoGraduacao = r.data));
      for (let p of this.postoGraduacao) {
        p.nome = p.nome.toUpperCase();
      }
    },

    async getEstadosCivisSicad() {
      await domainEstadosCivisSicad().then((r) => (this.estadosCivis = r.data));
    },

    async getGrauEscolaridade() {
      await domainGrauEscolaridade().then((r) => (this.grauEscolaridade = r.data));
    },

    openUploadImg() {
      let button = document.getElementById('uploadImg');
      button.click();
    },
    async uploadFileImg() {
      let validos = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
      let nomeArquivo = this.$refs.uploadImg.files[0].name;
      let tamanho = this.$refs.uploadImg.files[0].size;
      let valido = isArquivoValido(nomeArquivo, validos, tamanho);

      if (valido.tamanho && valido.extensoes)
        await sendDocumentFileWs(this.$refs.uploadImg.files[0], 'TOKEN', 'ssp').then(async (r) => {
          document.getElementById('imgFoto').src = await imgToBase64(this.$refs.uploadImg.files[0]);
          this.form.idAnexoFileImg = r.data.id;
        });
      else openNotification(typesNotification.error, 'Extensão ou tamanho de arquivo inválido.');
    },
    setConvencio(convenio) {
      this.form.convenios = new Array();
      switch (convenio) {
        case 'PARTICULAR':
          if (this.$refs.particular.checked) {
            this.form.convenios.push(convenio);
          } else {
            this.form.convenios.splice(convenio, 1);
          }
          break;
        case 'DOACAO':
          if (this.$refs.doacao.checked) {
            this.form.convenios.push(convenio);
          } else {
            this.form.convenios.splice(convenio, 1);
          }
          break;
        case 'IPASGO':
          if (this.$refs.ipasgo.checked) {
            this.form.convenios.push(convenio);
          } else {
            this.form.convenios.splice(convenio, 1);
          }
          break;
        default:
          break;
      }
    },
    async saveAndContinue(valid, back) {
      this.submitted = valid;
      await this.montarObjeto();
      if (!valid) {
        this.form.cpf = this.form.cpf.replaceAll('.', '').replace('-', '');
        await createPaciente(this.form).then((r) => {
          this.form.id = r.data.id;
          this.sicad = false;
          openNotification(typesNotification.success, 'Dados salvos com sucesso.');
          if (back) {
            this.$router.push({ path: '/paciente' });
          }
        });
      } else {
        this.verificarDadosSicad();
        openNotification(typesNotification.warning, 'Preencher campos obrigatórios');
        return false;
      }
    },
    verificarDadosSicad() {
      if (!this.form.rgCivil || !this.form.naturalidade || !this.form.dtNascimento || !this.form.idade || !this.form.nome) {
        this.sicad = true;
      }
    },
    async montarObjeto() {
      if (this.outForm.numero) {
        this.form.endereco.numero = this.outForm.numero;
      }
      if (this.outForm.complemento) {
        this.form.endereco.complemento = this.outForm.complemento;
      }
      this.form.documentos = this.dataDocuments;
    },
    getTipoDocumento() {
      this.enumTipoDocumento = EnumTipoDocumentoPaciente();
    },
    validarCpf() {
      let value = this.$refs.cpf.value;
      this.$refs.cpf.classList.value = ['form-control'];
      if (!validarCpf(value)) {
        this.$refs.cpf.classList.value = ['form-control is-invalid'];
      }
    },
    validarEmail() {
      let value = this.$refs.email.value;
      this.$refs.email.classList.value = ['form-control'];
      if (!isEmail(value)) this.$refs.email.classList.value = ['form-control is-invalid'];
    },
    async patchDataSicad(form) {
      this.form.nome = form.nome;
      this.form.tipoPaciente = form.tipoPaciente;
      this.form.email = form.email;
      this.form.telefoneCelular = form.telefoneCelular;
      this.form.telefoneResidencial = form.telefoneResidencial;
      this.form.posto = form.posto;
      this.form.idade = form.idade;
      this.form.rgCivil = form.rgCivil;
      this.form.rgMilitar = form.rgMilitar;
      this.form.imagem = form.imagem;
      this.form.tipoPaciente = form.vinculo;
      this.form.nomePai = form.nomePai;
      this.form.nomeMae = form.nomeMae;

      if (form.naturalidade) {
        this.form.naturalidade = form.naturalidade.nome + '-' + form.naturalidade.uf;
      }
      this.form.grauEscolaridade = form.grauEscolaridade;
      this.form.estadoCivil = form.estadoCivil;

      // endereço
      if (form.endereco) {
        this.outForm.cep = form.endereco.cep;
        this.outForm.logradouro = form.endereco.logradouro;
        if (form.endereco.bairro && form.endereco.bairro.id) {
          this.outForm.setor = form.endereco.bairro.nome;
        } else {
          this.outForm.setor = form.endereco.bairro;
        }

        if (form.endereco.municipio && form.endereco.municipio.id) {
          this.outForm.cidade = form.endereco.municipio.nome;
          this.outForm.uf = form.endereco.municipio.uf;
        } else {
          this.outForm.cidade = form.endereco.cidade;
          this.outForm.uf = form.endereco.uf;
        }
        this.outForm.numero = form.endereco.numero;
        this.outForm.complemento = form.endereco.complemento;
        this.outForm.lote = form.endereco.lote;
        this.outForm.quadra = form.endereco.quadra;
        this.$refs.cep.value = form.endereco.cep;

        this.form.endereco = this.outForm;
      }

      // convenios
      this.form.convenios.forEach((c) => {
        switch (c) {
          case 'PARTICULAR':
            this.$refs.particular.checked = true;
            break;
          case 'DOACAO':
            this.$refs.doacao.checked = true;
            break;
          case 'IPASGO':
            this.$refs.ipasgo.checked = true;
            break;
          default:
            break;
        }
      });

      // documentos
      this.dataDocuments = this.form.documentos;
      //carregar img
      await this.carregarImg(this.form.idAnexoFileImg);
    },
    async funcaoAtiva(form) {
      let funcaoAtiva = {};
      if (form.funcoesAtivas && form.funcoesAtivas.length > 1) {
        funcaoAtiva = form.funcoesAtivas.find((fa) => fa.principal);
        if (!funcaoAtiva) {
          funcaoAtiva = form.funcoesAtivas[0];
        }
      } else if (form.funcoesAtivas && form.funcoesAtivas.length === 1) {
        funcaoAtiva = form.funcoesAtivas[0];
      }

      if (funcaoAtiva.unidadeNome) {
        let funcao = funcaoAtiva.unidadeNome + ' - ' + funcaoAtiva.funcaoNome;
        document.getElementById('funcaoAtual').value = funcao;
        if (!this.form.funcaoAtual || this.form.funcaoAtual !== funcao) {
          this.form.funcaoAtual = funcao;
          /*await createPaciente(this.form).then(() => {
					});*/
        }
      }
    },
    stringTipoDocumento(documento) {
      let tipoDoc = this.enumTipoDocumento.find((etp) => etp.tipo === documento.tipoDocumento || etp.descricao === documento.tipoDocumento);
      if (tipoDoc) {
        return tipoDoc.descricao;
      }
    },
    async baixarArquivo(document) {
      await downloadDocumentFileWs(document.idAnexoFileWs, document.nomeArquivo);
    },
    async carregarImg(idImg) {
      if (idImg)
        await loadDocumentFileWs(idImg).then(async (img) => {
          document.getElementById('imgFoto').src = await imgToBase64(img);
        });
      else if (this.form.imagem) {
        let imgBlob = convertBase64ToBlob('data:image/jpg;base64,' + this.form.imagem);
        document.getElementById('imgFoto').src = await imgToBase64(imgBlob);
      } else {
        document.getElementById('imgFoto').src = imgPaciente;
      }
    },
  },
};
</script>

<style scoped>
#uploadImg {
  display: none;
}
</style>
